import {
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';

import {
  ActionIconButton,
  GeneralTableBox,
  HeadTableCell,
  NoDataSkeleton,
  RowTableCell,
  StatusChip,
  TableBodySkeleton,
} from '../../../common/components';
import { formatCurrencyAmount } from '../../utils/financeFormatters';

const CashAccountsDataTable = ({
  accounts,
  isLoading,
  onEdit,
  onDelete,
}) => (
  <GeneralTableBox>
    <Table stickyHeader size="small">
      <TableHead>
        <TableRow>
          <HeadTableCell>Caja</HeadTableCell>
          <HeadTableCell>Moneda</HeadTableCell>
          <HeadTableCell align="right" sx={{ textAlign: 'right' }}>Saldo inicial</HeadTableCell>
          <HeadTableCell align="right" sx={{ textAlign: 'right' }}>Saldo actual</HeadTableCell>
          <HeadTableCell>Estado</HeadTableCell>
          <HeadTableCell>Acciones</HeadTableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {isLoading ? (
          <TableBodySkeleton />
        ) : accounts.length ? (
          accounts.map((account) => (
            <TableRow key={account.uuid}>
              <RowTableCell>{account.name}</RowTableCell>
              <RowTableCell>{account.currency}</RowTableCell>
              <RowTableCell align="right" sx={{ textAlign: 'right' }}>
                {formatCurrencyAmount(account.initial_balance, account.currency)}
              </RowTableCell>
              <RowTableCell align="right" sx={{ textAlign: 'right' }}>
                {formatCurrencyAmount(account.current_balance, account.currency)}
              </RowTableCell>
              <RowTableCell>
                <StatusChip
                  size="small"
                  color={account.is_active ? 'success' : 'default'}
                  label={account.is_active ? 'Activa' : 'Inactiva'}
                />
              </RowTableCell>
              <RowTableCell>
                <ActionIconButton variant="edit" onClick={() => onEdit(account)} />
                <ActionIconButton variant="delete" onClick={() => onDelete(account)} />
              </RowTableCell>
            </TableRow>
          ))
        ) : (
          <NoDataSkeleton colSpan={6} message="No se encontraron cajas." />
        )}
      </TableBody>
    </Table>
  </GeneralTableBox>
);

export default CashAccountsDataTable;
